import Vue from "vue";
import App from "./App";
import router from "./router";
import editor from "@tinymce/tinymce-vue";
import CoreuiVue from "@coreui/vue";
import "./main.css";
import { iconsSet as icons } from "./assets/icons/icons.js";
import { i18n } from "./plugins/i18n";
import VueCookies from "vue-cookies";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import { BootstrapVueIcons, BIcon } from "bootstrap-vue";
import VueMoment from "vue-moment";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import ToggleButton from "vue-js-toggle-button";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import InfiniteLoading from "vue-infinite-loading";

const moment = require("moment");
require("moment/locale/th");
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "tinymce/tinymce";

// Theme
import "tinymce/themes/silver/theme";

// Skins
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

// Plugins
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";

import "babel-polyfill";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings as LuxonSettings } from "luxon";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

//Icon
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEyeSlash,
  faPowerOff,
  faUser,
  faStore,
  faBullhorn,
  faSearch,
  faFileUpload,
  faFilter,
  faSortDown,
  faPencilAlt,
  faTrashAlt,
  faTimes,
  faTimesCircle,
  faFileDownload,
  faEye,
  faBarcode,
  faPlus,
  faMinus,
  faStar,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faHome,
  faBuilding,
  faHotel,
  faCircle,
  faArrowRight,
  faClipboard,
  faBox,
  faSort,
  faHandHoldingUsd,
  faPlusCircle,
  faCheckCircle,
  faExclamationCircle,
  faEllipsisV,
  faCheck,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faStickyNote,
  faShippingFast,
  faMoneyBillWave,
  faReceipt,
  faUserCheck,
  faUserPlus,
  faPercent,
  faRobot,
  faFileExport,
  faUserFriends,
  faCommentAlt,
  faSmile,
  faAngry,
  faMobileAlt,
  faWindowMaximize,
  faMap,
  faImage,
  faSave,
  faPlusSquare,
  faCog,
  faCalendarAlt,
  faChevronCircleRight,
  faChevronCircleDown,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarFar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  fab,
  faFacebookF,
  faInstagram,
  faLine,
  faTwitter,
  faApple,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
library.add(
  fab,
  faFacebookF,
  faInstagram,
  faLine,
  faTwitter,
  faApple,
  faYoutube
);
library.add(
  faEyeSlash,
  faUser,
  faPowerOff,
  faStore,
  faBullhorn,
  faSearch,
  faFilter,
  faFileUpload,
  faSortDown,
  faPencilAlt,
  faTrashAlt,
  faTimes,
  faTimesCircle,
  faFileDownload,
  faEye,
  faBarcode,
  faPlus,
  faMinus,
  faStar,
  faStarFar,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faHome,
  faBuilding,
  faHotel,
  faCircle,
  faArrowRight,
  faClipboard,
  faBox,
  faSort,
  faHandHoldingUsd,
  faPlusCircle,
  faCheckCircle,
  faExclamationCircle,
  faEllipsisV,
  faCheck,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faStickyNote,
  faShippingFast,
  faMoneyBillWave,
  faReceipt,
  faUserCheck,
  faUserPlus,
  faPercent,
  faRobot,
  faFileExport,
  faUserFriends,
  faCommentAlt,
  faSmile,
  faAngry,
  faMobileAlt,
  faWindowMaximize,
  faMap,
  faImage,
  faSave,
  faPlusSquare,
  faCog,
  faCalendarAlt,
  faChevronCircleRight,
  faChevronCircleDown
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(VueAxios, axios);
Vue.use(vueNumeralFilterInstaller, { locale: "en-gb" });
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.component("BIcon", BIcon);

Vue.use(ToggleButton);
Vue.use(Vuelidate);
import VueSlickCarousel from "vue-slick-carousel";
const Slick = {
  install(Vue) {
    Vue.component("slick", VueSlickCarousel);
  },
};

Vue.use(Slick);
Vue.use(VueMoment, {
  moment,
});
Vue.component("datetime", Datetime);
Vue.component("editor", editor);

Vue.use(InfiniteLoading, {
  /* options */
});

let globalData = new Vue({
  data: {
    $isLoading: false,
    $campaignName: "",
  },
});

Vue.mixin({
  computed: {
    $isLoading: {
      get: function () {
        return globalData.$data.$isLoading;
      },
      set: function (isLoading) {
        globalData.$data.$isLoading = isLoading;
      },
    },
  },
});

// Choose MODE (INHOME, DEV , PROD )
const MODE = `${process.env.VUE_APP_MODE}`;
if (MODE == "DEV") {
  Vue.prototype.$baseUrl = "https://api-dev-brandadmin.dosetech.co/api";
  //SHARE COOKIE ON DOSETECH DOMAIN
  //Vue.$cookies.config("30d", null, ".dosetech.co");
} else if (MODE == "UAT") {
  Vue.prototype.$baseUrl = "https://uat-admin-api.d-dots.com/api";
  //SHARE COOKIE ON DOSETECH DOMAIN
  //Vue.$cookies.config("30d", null, ".d-dots.com");
} else if (MODE == "DEMO") {
  Vue.prototype.$baseUrl = "https://demo-tnl-admin.dosetech.co/api";
  //SHARE COOKIE ON DOSETECH DOMAIN
  //Vue.$cookies.config("30d", null, ".d-dots.com");
}

Vue.prototype.$formatDate = "DD MMM YYYY";
Vue.prototype.$formatDateTime = "DD MMM YYYY (HH:mm)";
Vue.prototype.$formatTime = "HH:mm";

// API request
Vue.axios.interceptors.request.use(function (config) {

  //check timestamp
  var timestamp = Vue.$cookies.get("tnl-timestamp");
  if (timestamp && store.getters.getTimestamp()) {
    if (timestamp > store.getters.getTimestamp()) {
      window.location.href = "/";
    }
  }

  config.headers.common['Authorization'] = Vue.$cookies.isKey("tnl-session-token")
    ? `Bearer ${Vue.$cookies.get("tnl-session-token")}`
    : "null";
  config.headers.common["API-KEY"] = "EC0mmErCeAp1KeY";
  config.headers.common['BrandId'] =
    store.getters.getCurrentBrandID() == null
      ? 0
      : store.getters.getCurrentBrandID();
  return config;
});
// API response
Vue.axios.interceptors.response.use(
  function (response) {
    return Promise.resolve(response.data);
  },
  function (error) {
    if (error.response.status == 401) {
      Vue.$cookies.remove("tnl-session-token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

LuxonSettings.defaultLocale = "th";

router.beforeEach((to, from, next) => {

  var dOrderUrl = `${process.env.VUE_APP_D_ORDER_URL}?brandID=${from.query.brandID}`
  var dChatbotUrl = `${process.env.VUE_APP_D_CHATBOT_URL}?brandID=${from.query.brandID}`

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!VueCookies.get("tnl-session-token")) {
      next({
        path: "/login",
      });
    } else {

      if (!to.query.brandID) {
        if (from.query.brandID) {
          if (to.params.id) {
            next({
              name: to.name,
              query: { brandID: from.query.brandID, ...to.query },
              params: { id: to.params.id, ...to.params },
            });
          } else {
            next({
              name: to.name,
              query: { brandID: from.query.brandID, ...to.query },
            });
          }
          return;
        } else {
          next();
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.requiresIsLogin)) {
    if (VueCookies.get("tnl-session-token")) {
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else {
    if (to.name == 'd-order') {
      window.open(dOrderUrl)
    } else if (to.name == 'd-chatbot') {
      window.open(dChatbotUrl)
    } else {
      next();
    }

  }
});

new Vue({
  el: "#app",
  library,
  i18n,
  router,
  icons,
  store,
  template: "<App/>",
  components: {
    App,
  },
});
